var _desc, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "16px",
    viewBox: "0 0 20 16",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4651 3.83015C17.4775 3.99823 17.4775 4.16636 17.4775 4.33444C17.4775 5.84459 16.4503 8.89712 16.4503 8.89712C16.4503 8.89712 11.3021 15.3687 6.12638 15.3687C3.86603 15.3687 1.76628 14.7323 0 13.6277C0.321152 13.6637 0.62991 13.6757 0.963419 13.6757C2.82847 13.6757 4.54537 13.0634 5.9164 12.0188C4.16247 11.9828 2.69263 10.8661 2.18621 9.32926C2.43326 9.36526 2.68027 9.38928 2.93968 9.38928C3.29787 9.38928 3.65609 9.34124 3.98956 9.25723C2.16153 8.897 0.790467 7.33613 0.790467 5.45107L0.790467 5.40306C1.32156 5.69122 1.93919 5.87132 2.59378 5.89531C1.51919 5.1989 0.81518 4.01025 0.81518 2.66548C0.81518 1.94508 1.01277 1.28471 1.35863 0.708382C3.32254 3.06171 6.27458 4.59855 9.58476 4.76667C9.52302 4.47851 9.48595 4.17837 9.48595 3.87819C9.48595 1.74096 11.2646 0 13.4755 0C14.6242 0 15.6617 0.468263 16.3905 1.22469C17.2921 1.0566 18.1567 0.732405 18.9226 0.288165C18.6261 1.18869 17.9962 1.94512 17.1686 2.42536C17.9715 2.34135 18.7496 2.12518 19.466 1.82504C18.9226 2.59345 18.2433 3.2778 17.4651 3.83015Z",
    id: "Shape",
    fill: "#22252B",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.66a508b10be386e30c24b58e87d233ca.svg";
export { ForwardRef as ReactComponent };